import React, { useState, useEffect } from "react"
import _ from "lodash"
import {
  Box,
  Flex,
  Heading,
  Link,
  List,
  ListItem,
  useTheme,
} from "@chakra-ui/react"
import Tooltip from "../../common/components/Tooltip"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faLink } from "@fortawesome/pro-light-svg-icons"
import { withRouter } from "next/router"
import { getGradeLabel } from "../../utilities/grades"
import GradeContext from "../../context/GradeContext"

import styles from "./css/NearbyFeaturesList.module.css"
import { removeArticles } from "../../utilities/text"
import TextLink from "../../common/components/TextLink"
import useColors from "../../common/hooks/useColors"

function getFeatureList({
  router,
  onSelect,
  searchStr,
  selectedFeature,
  currentUrl,
  allowedFeatureTypes,
  hideSearchList,
  features,
  title,
  isHidingLink,
  blueColor,
}) {
  if (
    !features ||
    features.length === 0 ||
    (allowedFeatureTypes &&
      allowedFeatureTypes.includes(features[0]?.type) === false) ||
    hideSearchList
  ) {
    return null
  }
  const retObj = _.sortBy(features, (feat) => removeArticles(feat.name)).map(
    (feat) => {
      return (
        <ListItem
          className={
            selectedFeature?._id === feat._id ? styles["selected"] : ""
          }
          key={feat.slug + "-" + feat.type}
        >
          <Flex align="center" justify="space-between">
            <Heading
              as="h6"
              size="sm"
              variant={"link"}
              onClick={() => {
                onSelect(feat)
              }}
            >
              <Link
                color={
                  selectedFeature?._id === feat._id
                    ? "brand.orangeColor"
                    : "brand.blueColor"
                }
              >
                {feat.name}
              </Link>
            </Heading>

            <GradeContext.Consumer>
              {(gradeType) => (
                <Heading as="h6" size="sm">
                  {feat.grade != null
                    ? getGradeLabel(feat.grade, feat.type, gradeType)
                    : null}
                  {!isHidingLink && (
                    <>
                      <TextLink
                        isnohover="true"
                        data-tip
                        data-tooltip-id={"search-" + feat.slug + feat.type}
                        className={styles["list-link"] + " no-hover-underline"}
                        to={"/" + feat.type + "s/" + feat.slug}
                      >
                        <FontAwesomeIcon color={blueColor} icon={faLink} />
                      </TextLink>
                      <Tooltip
                        class="card-tooltip"
                        id={"search-" + feat.slug + feat.type}
                      >
                        <Heading as="h6" size="xs">
                          View {feat.name}&rsquo;s page
                        </Heading>
                      </Tooltip>
                    </>
                  )}
                </Heading>
              )}
            </GradeContext.Consumer>
          </Flex>
        </ListItem>
      )
    },
  )
  // add title of section
  retObj.unshift(
    <ListItem
      key={title}
      className={styles["list-title"]}
      bg={"brand.darkBGColor"}
      mx={-5}
      px={5}
      py={2}
    >
      <Heading mb={0} as="h5" size="sm">
        {title}
      </Heading>
    </ListItem>,
  )
  return retObj
}

const NearbyFeaturesList = ({
  router,
  onSelect,
  searchStr,
  selectedFeature,
  currentUrl,
  allowedFeatureTypes,
  hideSearchList,
  features,
  noFeaturesText,
  isHidingLink,
}) => {
  const { blueColor } = useColors()
  const [featuresGroup, setFeaturesGroup] = useState(
    _.groupBy(features, "type"),
  )

  useEffect(() => {
    setFeaturesGroup(_.groupBy(features, "type"))
  }, [features])

  if (!features || !featuresGroup || featuresGroup.length === 0) {
    return null
  }
  if (
    !features.find(
      (f) => !allowedFeatureTypes || allowedFeatureTypes.includes(f?.type),
    )
  ) {
    return <p>{noFeaturesText}</p>
  }

  return (
    <Box mt={3} maxHeight="100%">
      <List spacing={3}>
        {getFeatureList({
          router,
          onSelect,
          searchStr,
          selectedFeature,
          currentUrl,
          allowedFeatureTypes,
          hideSearchList,
          features: featuresGroup.guide,
          title: "Guides",
          isHidingLink,
          blueColor,
        })}
        {getFeatureList({
          router,
          onSelect,
          searchStr,
          selectedFeature,
          currentUrl,
          allowedFeatureTypes,
          hideSearchList,
          features: featuresGroup.gym,
          title: "Gyms",
          isHidingLink,
          blueColor,
        })}
        {getFeatureList({
          router,
          onSelect,
          searchStr,
          selectedFeature,
          currentUrl,
          allowedFeatureTypes,
          hideSearchList,
          features: featuresGroup.area,
          title: "Areas",
          isHidingLink,
          blueColor,
        })}
        {getFeatureList({
          router,
          onSelect,
          searchStr,
          selectedFeature,
          currentUrl,
          allowedFeatureTypes,
          hideSearchList,
          features: featuresGroup.problem,
          title: "Problems",
          isHidingLink,
          blueColor,
        })}
        {getFeatureList({
          router,
          onSelect,
          searchStr,
          selectedFeature,
          currentUrl,
          allowedFeatureTypes,
          hideSearchList,
          features: featuresGroup.route,
          title: "Routes",
          isHidingLink,
          blueColor,
        })}
      </List>
    </Box>
  )
}

export default withRouter(NearbyFeaturesList)
